
import { USER_AUDIT_EVENT_METADATA } from './user-audit-event.metadata';
import { UserAuditEvent } from './user-audit-event.model';
import { GenericEntityDecorator } from '@scisys-uim/uim-common';


export abstract class UserAuditEventEntityDecoratorBase extends GenericEntityDecorator<UserAuditEvent, any> {
  constructor() {
    super(USER_AUDIT_EVENT_METADATA, {
    }, {
    });
  }
  toKeyObjectFromRouteParams(params: any): any {
      return null;
  }
  toKeyUrlPathSegments(key: any): string {
      return null;
  }
  toKeyRouteSegments(item: UserAuditEvent): any[] {
      return null;
  }
}




